import React from 'react';
import {View} from 'react-native';

import Screen from '../../../../../shared/components/screen';

import {useStyles} from '../../../../../shared/hooks/styles';
import {ApplicationsFilter} from '../../../common/applicationsFilter';
import {Props} from './model';
import {CustomScrollView} from '../../../../../shared/components/scrollView';

export default ({}: Props) => {
  const styles = useStyles(({theme}) => ({
    container: {
      paddingBottom: theme.screen.bottomOffset,
    },
  }));
  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.container}>
          <ApplicationsFilter />
        </View>
      </CustomScrollView>
    </Screen>
  );
};
